import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-files-folder-check-icon',
  templateUrl: './files-folder-check.component.html'
})
export class FilesFolderCheckComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
